import { HttpTypes } from "@medusajs/types"
import { clx } from "@modules/common/components/ui"
import React from "react"

type OptionSelectProps = {
  option: HttpTypes.StoreProductOption
  current: string | undefined
  updateOption: (title: string, value: string) => void
  title: string
  disabled: boolean
  /** Values used by this product's variants; global options carry more. */
  availableValues?: string[]
  "data-testid"?: string
}

const OptionSelect: React.FC<OptionSelectProps> = ({
  option,
  current,
  updateOption,
  title,
  availableValues,
  "data-testid": dataTestId,
  disabled,
}) => {
  const all = (option.values ?? []).map((v) => v.value)
  // Keep the order in which the product's variants were created (S, M, L...).
  const values = availableValues ? availableValues.filter((v) => all.includes(v)) : all

  return (
    <div className="flex flex-col gap-y-3">
      <span className="zl-label text-zl-steel">
        {title} <span className="text-zl-mute">{"//"}</span>{" "}
        <span className="text-zl-ink">{current ?? "Selecciona"}</span>
      </span>
      <div className="flex flex-wrap gap-2" data-testid={dataTestId}>
        {values.map((v) => (
          <button
            onClick={() => updateOption(option.id, v)}
            key={v}
            className={clx(
              "group min-w-[64px] px-3 h-10 flex items-center gap-x-2 border text-sm transition-colors duration-100 ease-linear disabled:opacity-40",
              v === current
                ? "border-zl-ink bg-zl-ink text-zl-canvas"
                : "border-zl-line bg-white hover:border-zl-ink"
            )}
            disabled={disabled}
            data-testid="option-button"
            aria-pressed={v === current}
          >
            <span
              className={clx(
                "w-1 h-1 shrink-0",
                v === current ? "bg-zl-red" : "bg-zl-mute group-hover:bg-zl-ink"
              )}
              aria-hidden
            />
            {v}
          </button>
        ))}
      </div>
    </div>
  )
}

export default OptionSelect
